export const pushMyAcuvueId = (id: string): void => {
  window?.dataLayer?.push({
    event: 'userID',
    'myacuvue_id': id,
  });
  localStorage?.removeItem('isMyAcuvueId');
};
